module.exports = __webpack_public_path__ + "img/1-21060410492aO.b99c2a14.png";